"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NO_PROGRESS_TIMER = void 0;
// A timer used to denote no progress

const NO_PROGRESS_TIMER = exports.NO_PROGRESS_TIMER = {
  isPaused: true,
  originalDelay: 100,
  tag: undefined,
  delayLeft: 100,
  currentProgress: 0,
  id: 'undefined'
}; // DOUBLE cast to make sure `NoProgressTimerType` is the same as `Timer`, done this way to avoid circular dependencies in module definitions